var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnbStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150px",
    height: "150px",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons / onb-step-3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "36.6050011%",
    y1: "15.1651008%",
    x2: "65.6362796%",
    y2: "121.150643%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC124",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89422",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.2936652,0 C15.4727688,0 6.59333134,8.88830032 6.59333134,19.7091652 C6.59333134,30.5300473 15.4727688,39.4094763 26.2936652,39.4094763 C37.1145164,39.4094763 45.9939541,30.5300473 45.9939541,19.7091652 C45.9939541,8.88830032 37.1145164,0 26.2936652,0 Z M26.2936652,45.4629467 C11.804586,45.4629467 0,57.2940906 0,71.7831359 L0,84.0582195 C0.00509210775,86.5503208 2.02149153,88.5706646 4.51357816,88.5806598 L48.0294835,88.5806598 C49.232745,88.5852131 50.3884307,88.1110685 51.2417587,87.2627226 C52.0950867,86.4143768 52.5759903,85.2614872 52.5784498,84.0582195 L52.5784498,71.7831359 C52.5784498,57.2940734 40.7827448,45.4629467 26.2936652,45.4629467 L26.2936652,45.4629467 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-29.5%",
    y: "-15.2%",
    width: "162.8%",
    height: "137.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "56.9004782%",
    x2: "50.9086715%",
    y2: "72.7429778%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83BFFC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C8BF7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.2847846,45.4629467 C40.7738641,45.4629467 52.5784045,57.2940906 52.5784045,71.7831359 L52.5784045,71.7831359 L52.5784045,84.0582195 C52.575945,85.2614795 52.0950474,86.4143623 51.2417291,87.2627068 C50.3884108,88.1110514 49.2327365,88.5852013 48.0294827,88.5806596 L48.0294827,88.5806596 L4.51353266,88.5806596 C2.02146381,88.5706397 0.00509197148,86.5503032 0,84.0582195 L0,84.0582195 L0,71.7831359 C0,57.2940734 11.7957051,45.4629467 26.2847846,45.4629467 Z M26.2847846,0 C37.1056358,0 45.9585196,8.88830032 45.9585196,19.7091652 C45.9585196,30.5300473 37.1056358,39.4094763 26.2847846,39.4094763 C15.4638871,39.4094763 6.58444952,30.5300473 6.58444952,19.7091652 C6.58444952,8.88830032 15.4638871,0 26.2847846,0 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-29.5%",
    y: "-15.2%",
    width: "162.8%",
    height: "137.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-9"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "41.5324059%",
    y1: "46.9145569%",
    x2: "50%",
    y2: "77.9766613%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCFCF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.53124949,0 C2.02880849,0 0,2.02882044 0,4.53126144 L0,41.9140664 C0,44.4165074 2.02880847,46.4450777 4.53124949,46.4453279 L26.2405139,46.4453279 L47.0471071,46.4453279 L67.9244803,55.1538225 C69.3221665,55.7362218 70.9183818,55.5820769 72.1787962,54.7429874 C73.4392106,53.903898 74.1972711,52.4907426 74.1992184,50.9765723 L74.1992184,4.53126144 C74.1992184,2.02882044 72.1704099,0 69.6679689,0 L4.53124949,0 Z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-20.9%",
    y: "-24.3%",
    width: "144.5%",
    height: "159.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-13"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "55.2394407%",
    x2: "51.675474%",
    y2: "67.2684385%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.4461494,18.1250121 C60.590627,18.118091 60.7353531,18.118091 60.8798307,18.1250121 L84.0936505,18.1250121 C85.7364503,18.0885981 87.270286,18.9441958 88.1023778,20.3611434 C88.9344696,21.7780909 88.9344696,23.5344221 88.1023778,24.9513696 C87.270286,26.3683172 85.7364503,27.2239149 84.0936505,27.1875009 L60.8798358,27.1875009 C58.4142242,27.2501565 56.3500765,25.3318794 56.2321826,22.868291 C56.1142887,20.4047027 57.9858268,18.2980851 60.4461545,18.1250121 L60.4461494,18.1250121 Z",
    id: "path-15"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-47.7%",
    y: "-55.3%",
    width: "201.5%",
    height: "245.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-16"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-/-onb-step-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_interview_3265933",
    transform: "translate(2.500000, 2.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-30",
    transform: "translate(0.000000, 56.419381)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90.6181708,20.0003197 L85.7500451,-17.3198244 L0.292178999,82.6825184 C7.26914261,103.072305 19.0835277,109.696145 35.7353343,102.554037 C46.8479557,97.7877353 71.9292923,106.495516 69.6552229,84.4629467 C68.8995361,77.1413928 75.8871854,55.6538504 90.6181708,20.0003197 Z",
    fillOpacity: 0.15,
    fill: "url(#linearGradient-5)",
    mask: "url(#mask-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-30",
    transform: "translate(92.421595, 56.419381)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-9)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-6)",
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90.1965753,20.0003197 L85.3284496,-17.3198244 L-0.129416496,82.6825184 C6.84754711,103.072305 18.6619322,109.696145 35.3137388,102.554037 C46.4263602,97.7877353 71.5076968,106.495516 69.2336274,84.4629467 C68.4779406,77.1413928 75.4655899,55.6538504 90.1965753,20.0003197 Z",
    fillOpacity: 0.15,
    fill: "url(#linearGradient-5)",
    mask: "url(#mask-8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-30",
    transform: "translate(35.391555, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-13)",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-10)",
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M98.2266157,-12.580299 L102.06362,-16.4682928 L-7.10542736e-15,45.371699 C12.2440462,68.9149532 26.6919727,77.1155265 43.3437793,69.9734187 C54.4564006,65.2071167 79.5377372,73.9148977 77.2636679,51.8823281 C76.5079811,44.5607742 83.4956304,23.0732318 98.2266157,-12.580299 Z",
    fillOpacity: 0.15,
    fill: "url(#linearGradient-14)",
    mask: "url(#mask-12)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-16)",
    xlinkHref: "#path-15"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#58585C",
    xlinkHref: "#path-15"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnbStep3);
export default __webpack_public_path__ + "static/media/onb-step-3.304a9ee467f3e348e62f0577723b7489.svg";
export { ForwardRef as ReactComponent };